import { computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
import { PODCASTS_PARTNERS } from './';
export default defineComponent({
    name: 'PodcastPartner',
    props: {
        podcast: {
            required: true,
            type: Object,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const currentPartner = computed(() => {
            const pr = parseInt((Math.random() * 100000000).toFixed(0), 10);
            const partners = PODCASTS_PARTNERS(pr);
            const key = props.podcast.url.replace(/\/\d+.+/g, '');
            let attrs = {};
            let component = 'div';
            if (partners[key].to) {
                attrs = {
                    href: partners[key].to,
                    target: '_blank',
                };
                component = 'a';
            }
            return {
                ...partners[key],
                attrs,
                component,
            };
        });
        return {
            css,
            currentPartner,
        };
    },
});
